import * as React from 'react';

function Broom(props) {
    return (
        <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect
                x="0.5"
                y="0.5"
                width="25"
                height="25"
                rx="12.5"
                stroke="#B0C9EB"
            />
            <g clipPath="url(#clip0_1124_639)">
                <path
                    d="M14.8244 14.1229C14.6165 14.3297 15.8717 14.8466 15.991 14.9211C17.5157 15.8558 17.7813 16.9973 16.2798 18.2009C15.4866 18.8378 14.5588 19.2142 13.5693 19.2803C13.1419 19.3093 11.7983 19.4375 11.8637 18.7509C11.9253 18.1181 13.4307 18.387 13.885 18.3291C14.2739 18.2794 15.7408 17.7542 15.9987 17.4853C16.3144 17.1545 16.2952 16.41 15.9487 16.104C15.6022 15.7979 13.4268 15.0658 13.0418 15.1899C12.5721 15.7814 12.0601 16.4762 11.6712 17.1255C11.3709 17.6218 10.4469 19.6774 10.1812 19.8676C9.31878 20.4921 9.92325 18.6599 10.1004 18.2588C10.3468 17.6921 11.8291 15.3884 11.856 15.0948C11.8714 14.9252 11.2746 14.4661 11.5903 13.9947C11.7289 13.7879 12.4759 13.9864 12.9032 13.4074C13.2459 12.9441 15.0131 9.76777 15.0054 9.37072C15.0015 9.14325 14.682 9.01504 14.9284 8.65935C15.1748 8.30366 15.7985 8.36984 16.1758 8.36984C16.6186 8.48564 16.0526 9.82981 15.941 10.0945C15.4751 11.1616 14.7513 12.1294 14.193 13.1427C14.1199 13.275 14.0275 13.3577 14.066 13.5314C15.4096 13.0889 16.8919 12.7911 18.1548 12.1128C19.1673 11.5669 20.6804 10.2723 19.5408 9.01917C18.8747 8.28712 17.019 7.57575 16.0834 7.33173C14.4163 6.89332 10.2005 6.60795 8.59882 7.14975C8.31006 7.24901 7.39758 7.7784 7.23203 8.03069C6.42736 9.24665 8.87602 9.64369 8.32931 10.4957C7.9828 11.0375 6.44276 9.51962 6.2079 9.12257C5.70739 8.27058 6.21945 7.47235 6.94712 7.02567C9.23023 5.62774 14.5049 5.85108 17.0113 6.56245C18.0316 6.85196 20.1183 7.74945 20.6689 8.73793C22.4168 11.8771 16.8342 13.8168 14.8244 14.1187V14.1229Z"
                    fill="#045300"
                />
            </g>
            <defs>
                <clipPath id="clip0_1124_639">
                    <rect
                        width="15"
                        height="14"
                        fill="white"
                        transform="translate(6 6)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}

export default Broom;
